import Dashboard from "@/pages/Dashboard.vue";

export default [
  {
    path: "/",
    redirect: "/dashboard/",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/pengaturan",
    component: () => import("@/pages/pengaturan/pengaturan-page.vue"),
    meta: { requiresAuth: true },
  },
];
